import React, { useEffect, useState } from "react";
import { Loader2, Search } from "lucide-react";
import { format } from "date-fns";
import InputLine from "~/components/RegisterForm/InputLine";
import InputLineGroup from "~/components/RegisterForm/InputLineGroup";
import Input from "~/components/RegisterForm/Input";
import DatePicker from "~/components/RegisterForm/DatePicker";
import SelectPopover from "~/components/RegisterForm/SelectPopover";
import FindGeneric from "~/components/Finds/FindGeneric";
import { getData } from "~/functions/gridFunctions";

export const typeOptions = [
  { value: "Payable", label: "Payable" },
  { value: "Receivable", label: "Receivable" },
];

export default function Step1Filter({
  auth,
  InputContext,
  loading,
  onTypeChange,
}) {
  const [paymentMethodOptions, setPaymentMethodOptions] = useState([]);

  useEffect(() => {
    async function loadMethods() {
      const data = await getData("paymentmethods", { limit: 100 });
      setPaymentMethodOptions(
        (data || []).filter(Boolean).map((method) => ({
          value: method.id,
          label: method.description,
        }))
      );
    }
    loadMethods();
  }, []);

  return (
    <InputLineGroup title="FILTER" activeMenu>
      <FindGeneric
        route="filials"
        title="Filial"
        scope="filial"
        required
        InputContext={InputContext}
        defaultValue={
          auth.filial?.id !== 1
            ? { id: auth.filial?.id, name: auth.filial?.name }
            : { id: null, name: "" }
        }
        fields={[
          {
            title: "Name",
            name: "name",
          },
        ]}
      />

      <InputLine title="Type">
        <SelectPopover
          name="type"
          title="Type"
          grow
          required
          options={typeOptions}
          defaultValue={typeOptions[0]}
          onChange={(option) => onTypeChange(option?.value)}
          InputContext={InputContext}
        />
      </InputLine>

      <InputLine title="Period">
        <DatePicker
          name="date_from"
          title="From"
          required
          grow
          placeholderText="MM/DD/YYYY"
          InputContext={InputContext}
        />
        <DatePicker
          name="date_to"
          title="To"
          required
          grow
          placeholderText="MM/DD/YYYY"
          InputContext={InputContext}
        />
        <DatePicker
          name="conciliation_date"
          title="Conciliation Date"
          required
          grow
          defaultValue={new Date()}
          placeholderText="MM/DD/YYYY"
          InputContext={InputContext}
        />
        <Input
          type="text"
          name="expected_amount"
          title="Expected Amount"
          grow
          onlyFloat
          placeholder="0.00"
          InputContext={InputContext}
        />
      </InputLine>

      <InputLine title="Payment Methods">
        <SelectPopover
          name="paymentmethod_ids"
          title="Payment Methods"
          grow
          isMulti
          isSearchable
          isClearable
          options={paymentMethodOptions}
          InputContext={InputContext}
        />
      </InputLine>

      <InputLine title="Details">
        <Input
          type="text"
          name="memo"
          title="Memo"
          grow
          placeholder="Chase invoice July"
          InputContext={InputContext}
        />
      </InputLine>

      <InputLine>
        <button
          type="submit"
          disabled={loading}
          className="bg-primary text-white rounded-md p-1 px-2 h-8 mt-3 flex flex-row items-center justify-center text-xs gap-1 hover:opacity-80 disabled:opacity-50 transition-all"
        >
          {loading ? (
            <Loader2 size={16} className="animate-spin" />
          ) : (
            <Search size={16} />
          )}
          Search processes
        </button>
      </InputLine>
    </InputLineGroup>
  );
}
